
import { incentiveService } from "@crescentParts/Services/IncentiveService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface IncentiveFormParameter {
    ContractorBusinessName: string;
    DateOfSale: string;
    CrescentInvoiceNumber: string;
    UnitSold : string;
    TypeOfEquipemnt : string;
    ModelNumber: string;
    ThermostatModelNumber: string;
    Manufacturer: string;
    CentralACSize: string;
    CertificationNumber: string;
    BusinessName: string;
    LocationAddress: string;
    Name:string;
    PhoneNumber:string;
    Email:string;
    AccountNumber:string;
    onSuccess: () => void;
    onError: (error: string) => void;
}

type HandlerType = Handler<IncentiveFormParameter>;

export const Subscribe: HandlerType = async props => {
    const data = {
        ContractorBusinessName : props.parameter.ContractorBusinessName,
        DateOfSale: props.parameter.DateOfSale,
        CrescentInvoiceNumber: props.parameter.CrescentInvoiceNumber,
        UnitSold : props.parameter.UnitSold,
        TypeOfEquipemnt : props.parameter.TypeOfEquipemnt,
        ModelNumber: props.parameter.ModelNumber,
        ThermostatModelNumber: props.parameter.ThermostatModelNumber,
        Manufacturer: props.parameter.Manufacturer,
        CentralACSize: props.parameter.CentralACSize,
        CertificationNumber: props.parameter.CertificationNumber,
        BusinessName: props.parameter.BusinessName,
        LocationAddress: props.parameter.LocationAddress,
        Name: props.parameter.Name,
        PhoneNumber: props.parameter.PhoneNumber,
        Email: props.parameter.Email,
        AccountNumber: props.parameter.AccountNumber

    };
    try {
        await incentiveService({ IncentiveForm: data });
        props.parameter.onSuccess();
    } catch (err) {
        props.parameter.onError(err?.errorMessage || err);
    }
};

export const chain = [Subscribe];

const submitIncentive = createHandlerChainRunner(chain, "SubscribeNewsletter");
export default submitIncentive;